<template>
	<div v-bind:class="['item-block',className]" v-bind:data-json="JSON.stringify(data)">
		<div v-bind:class="itemClass(data)" v-if="typeof data.itemHash !== 'undefined' && getItemDef(data)" v-bind:style="'background-image:url(https://www.bungie.net' + getItemDef(data).displayProperties.icon + ')'"></div>
		<div class="borderless-item" v-else-if="data.progressionHash === 540048094" v-bind:style="'background-image:url(https://www.bungie.net' + getItemDef({itemHash:1460578929}).displayProperties.icon + ')'"  v-bind:data-json="JSON.stringify(getItemDef({itemHash:1460578929}))"></div>
		<div class="borderless-item" v-else-if="typeof data.progressionHash !== 'undefined' && getProgressionDef(data).factionHash"
		    v-bind:style="'background-image:url(https://www.bungie.net' + getFactionDef(getProgressionDef(data)).displayProperties.icon + ')'"></div>
		<div class="borderless-item" v-else-if="typeof data.progressionHash !== 'undefined' && getProgressionDef(data)"
		    v-bind:style="'background-image:url(https://www.bungie.net' + getProgressionDef(data).displayProperties.icon + ')'"></div>
		<div class="borderless-item" v-else-if="typeof data.factionHash !== 'undefined' && getFactionDef(data)" v-bind:style="'background-image:url(https://www.bungie.net' + getFactionDef(data).displayProperties.icon + ')'"></div>
		<div class="primary-stat" v-if="typeof data.objectives !== 'undefined'">{{ itemObjectivePercentage(data.objectives) }}%</div>
		<div v-bind:class="['primary-stat',data.damageTypeHash&&getDamageDef(data).displayProperties.name.toLowerCase()]" v-else-if="typeof data.primaryStat !== 'undefined'">{{ data.primaryStat.value }}</div>
		<div class="primary-stat" v-else-if="typeof data.currentProgress !== 'undefined'">{{ data.currentProgress }}</div>
		<!-- <div class="primary-stat" v-else>{{ data.quantity || getItemDef(data) && getItemDef(data).inventory && getItemDef(data).inventory.maxStackSize || 1 }}</div> -->
		<div class="primary-stat" v-else>{{ data.quantity ||  1 }}</div>
	</div>
</template>

<style>
	.item-block {
		position: relative;
		display: inline-block;
		overflow: hidden;
		width: 50px;
		height: 50px;
		margin: 0 3px;
	}

	.item {
		position: relative;
		display: inline-block;
		box-sizing: content-box;
		width: 44px;
		height: 44px;
		vertical-align: bottom;
		/* margin: 3px; */
		border: 3px solid #FFF;
		background-size: cover;
	}

	.borderless-item {
		position: relative;
		display: inline-block;
		box-sizing: content-box;
		/* border: 3px solid #FFFFFF; */
		width: 50px;
		height: 50px;
		/* margin: 3px; */
		background-size: cover;
	}

	.item-block .primary-stat {
		font-size: 10px;
		font-weight: bold;
		line-height: normal;
		position: absolute;
		z-index: 1;
		right: 0;
		bottom: 0;
		box-sizing: content-box;
		width: auto;
		min-width: 10px;
		padding: 0 2px;
		text-align: center;
		color: #000;
		background: rgba(255, 255, 255, .9);
	}
	.item-block .primary-stat.arc {
		background: #85C5EC;
	}

	.item-block .primary-stat.solar {
		background: #F2721B;
	}

	.item-block .primary-stat.void {
		background: #B184C5;
	}
</style>


<script>
	export default {
		props: ['data','className'],
		data: function () {
			return {
				DestinyInventoryItemDefinition: DestinyInventoryItemDefinition,
				DestinyProgressionDefinition: DestinyProgressionDefinition,
				DestinyObjectiveDefinition: DestinyObjectiveDefinition,
				DestinyFactionDefinition: DestinyFactionDefinition,
				DestinyDamageTypeDefinition:DestinyDamageTypeDefinition
			};
		},
		methods: {
			getItemDef(item) {
				return DestinyInventoryItemDefinition[item.itemHash];
			},
			getProgressionDef(item) {
				return DestinyProgressionDefinition[item.progressionHash];
			},
			getFactionDef(item) {
				return DestinyFactionDefinition[item.factionHash];
			},
			getDamageDef(item) {
				return DestinyDamageTypeDefinition[item.damageTypeHash];
			},
			itemClass(item) {
				let itemDef = this.getItemDef(item);
				if(itemDef.inventory.tierType === 1 || itemDef.inventory.tierType === 0) {
					return "borderless-item";
				}
				if(itemDef.itemCategoryHashes && itemDef.itemCategoryHashes.indexOf(34) > -1) {
					return "borderless-item";
				}
				return "item";
			},
			itemObjectivePercentage: function (objectives) {
				let progress = 0;
				let total = 0;
				for (let objective of objectives) {
					if (DestinyObjectiveDefinition[objective.objectiveHash]) {
						total += DestinyObjectiveDefinition[objective.objectiveHash].completionValue;
						progress += objective.progress;
					}
				}
				if (total === 0) {
					return 0;
				}
				return Math.round(progress / total * 100);
			}
		},
	}
</script>


// WEBPACK FOOTER //
// Item.vue?60ff4bb3